__webpack_require__.p = "https://site-clientes-assets.getninjas.com.br/_next/";